import { render, staticRenderFns } from "./FacebookLoginButton.vue?vue&type=template&id=ed0cc29a&scoped=true"
import script from "./FacebookLoginButton.vue?vue&type=script&lang=js"
export * from "./FacebookLoginButton.vue?vue&type=script&lang=js"
import style0 from "./FacebookLoginButton.vue?vue&type=style&index=0&id=ed0cc29a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0cc29a",
  null
  
)

export default component.exports